
export class FieldValidationResult
{
    public readonly isValid:boolean;
    public readonly message:string;

    constructor(isValid:boolean, message?:string)
    {
        this.isValid = isValid;
        this.message = message;
    }

    public static isValid():FieldValidationResult
    {
        return new FieldValidationResult(true)
    }

    public static isNotValid(message?:string):FieldValidationResult
    {
        return new FieldValidationResult(false, message)
    }
}

// -----------------------------------------------------------------------------

// export type ValidationFn = (props?:any) => FieldValidationResult;

export type ValidationMessage = ((props:any) => string) | string;

export type IsValidFn = (value:string, props?:any) => boolean;

// -----------------------------------------------------------------------------

export class OldValidator
{
    // -------------------------------------------------------------------------

    public static validationFn(isValidFn:IsValidFn)
    {
        return (message?:ValidationMessage, validatorProps = {} as any) =>
        {
            return (value, props) =>
            {
                const allProps = Object.assign(validatorProps, props);

                const isValid = isValidFn(value, allProps);

                const msg = isValid ? '' : this._getMessage(message, {value, ...allProps});

                return isValid
                    ? FieldValidationResult.isValid()
                    : FieldValidationResult.isNotValid(msg);
            };
        }
    }

    // -------------------------------------------------------------------------

    private static _getMessage(message:ValidationMessage, props):string
    {
        let msg = '';

        if (typeof message === 'string')
            msg = message;

        if (typeof message === 'function')
            msg = message(props);

        return msg;
    }

    // -------------------------------------------------------------------------

    public static required = OldValidator.validationFn((value) =>
    {
        return !!value;
    });

    public static minLength = OldValidator.validationFn((value, props) =>
    {
        const {minLength = 1} = props;
        return value.length >= minLength;
    });

    public static maxLength = OldValidator.validationFn((value, props) =>
    {
        const {maxLength = 255} = props;
        return value.length <= maxLength;
    });

    // -------------------------------------------------------------------------

    public static regexp = OldValidator.validationFn((value, props) =>
    {
        const {regexp} = props;
        return regexp.test(value);
    });

    public static alpha = OldValidator.validationFn((value) =>
    {
        return /^[a-zA-Z]+$/.test(value);
    });

    public static alphaAndSpace = OldValidator.validationFn((value) =>
    {
        return /^[a-zA-Z ]+$/.test(value);
    });

    public static numeric = OldValidator.validationFn((value) =>
    {
        return /^[0-9]+$/.test(value);
    });

    public static numericAndSpace = OldValidator.validationFn((value) =>
    {
        return /^[0-9 ]+$/.test(value);
    });

    public static alphaAndNumeric = OldValidator.validationFn((value) =>
    {
        return /^[a-zA-Z0-9]+$/.test(value);
    });

    public static alphaNumericAndSpace = OldValidator.validationFn((value) =>
    {
        return /^[a-zA-Z0-9 ]+$/.test(value);
    });

    // -------------------------------------------------------------------------
}

export class OldValidators
{
    // -------------------------------------------------------------------------

    constructor(private validators:any[] )
    {
    }

    // -------------------------------------------------------------------------

    public validate(value, props?:any):FieldValidationResult
    {
        let result:FieldValidationResult;

        for (let validator of this.validators)
        {
            result = validator(value, props);

            // if (typeof result === 'boolean')
            //     result = result
            //            ? FieldValidationResult.isValid()
            //            : FieldValidationResult.isNotValid();

            if (!result.isValid) {
                return result;
            }
        }

        return result ? result : FieldValidationResult.isValid();
    }

    // -------------------------------------------------------------------------
}
